'use client';

import { type PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchVipCMS } from '@/api/cms';
import GeneralSkeleton from '@/components/skeletons/GeneralSkeleton';
import { fetchToStore } from '@/helpers/fetchers';
import { useGetCommonStore } from '@/store';

export default function Layout({ children }: PropsWithChildren) {
  const {
    i18n: { language },
  } = useTranslation();
  const useCommonStore = useGetCommonStore();

  const [isLoading, setIsLoading] = useState(true);
  const setState = useCommonStore.setState;

  useEffect(() => {
    fetchToStore(() => fetchVipCMS(language), 'vip', setState)
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setIsLoading(false));
  }, [language, setState]);

  return isLoading ? <GeneralSkeleton /> : children;
}
